import { apiClient } from "./client";

export const listLeadTypes = () => apiClient.get("/subscriptions/lead-types").then((r) => r.data);
export const listMyCounties = () => apiClient.get("/subscriptions/counties").then((r) => r.data);
export const addCounty = (county_id) =>
  apiClient.post("/subscriptions/counties", { county_id }).then((r) => r.data);
export const removeCounty = (agent_county_id) =>
  apiClient.delete(`/subscriptions/counties/${agent_county_id}`).then((r) => r.data);
export const cancelSubscription = (subscription_id) =>
  apiClient.delete(`/subscriptions/${subscription_id}`).then((r) => r.data);
export const cancelLeadType = (lead_type_name) =>
  apiClient.delete(`/subscriptions/lead-types/${encodeURIComponent(lead_type_name)}`).then((r) => r.data);
export const listSubscriptions = () => apiClient.get("/subscriptions/").then((r) => r.data);
export const createCheckout = (data) =>
  apiClient.post("/subscriptions/checkout", data).then((r) => r.data);
export const createBulkCheckout = (data) =>
  apiClient.post("/subscriptions/checkout/bulk", data).then((r) => r.data);
export const claimPendingSubscriptions = () =>
  apiClient.post("/subscriptions/claim-pending").then((r) => r.data);
export const claimSession = (session_id) =>
  apiClient.post(`/subscriptions/claim-session?session_id=${encodeURIComponent(session_id)}`).then((r) => r.data);
export const getCheckoutStatus = (session_id) =>
  apiClient.get(`/payments/v1/checkout/status/${session_id}`).then((r) => r.data);
export const getAccess = () => apiClient.get("/subscriptions/access").then((r) => r.data);
export const getBillingPeriod = () => apiClient.get("/subscriptions/billing-period").then((r) => r.data);
export const prorationPreview = (data) =>
  apiClient.post("/subscriptions/proration-preview", data).then((r) => r.data);
export const addItems = (data) =>
  apiClient.post("/subscriptions/add-items", data).then((r) => r.data);
export const removeItems = (data) =>
  apiClient.post("/subscriptions/remove-items", data).then((r) => r.data);
